import { render, staticRenderFns } from "./examHouseDevice.vue?vue&type=template&id=2fb36962&scoped=true"
import script from "./examHouseDevice.vue?vue&type=script&lang=js"
export * from "./examHouseDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb36962",
  null
  
)

export default component.exports